/**
 * Базово проверяет, является ли строка валидным URL
 *
 * @todo 'ftp:/example.com', 'http://example', 'http:example.com' являются валидными (почему-то)
 */
export function isValidUrl(value: string): boolean {
  try {
    new URL(value);

    return true;
  } catch {
    return false;
  }
}
